<!-- =========================================================================================
  File Name: AccountDashboard.vue
  Description: load and display dashboard info
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 22062020
========================================================================================== -->

<template>
  <div id="user-tab-edit-dashboard">
    <!-- <vx-card v-if="hasDocument === true" ref="vxAltert" class="mb-6" noRadius card-border cardBackground="LightYellow" >
      <div class="flex justify-between w-full">
        <vs-button color="primary" type="line" :to="{ path: `/${this.$route.params.lang}/upload/document`}">need to upload yout documentation to full access panel feature's  ...</vs-button>
        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click="closeDocumentNotification"></vs-button>
      </div>
    </vx-card> -->
    <div v-if="this.cardData.length  > 0" class="vx-row">
      <div  v-for="item in this.cardData" v-bind:key="item.title" class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          hideChart
          class="mb-5"
          :icon="item.icon"
          icon-right
          :statistic ="item.value"
          :statisticTitle="item.title" 
          :color="item.color"/>
      </div>
    </div>
    <div class="vx-col w-full">
      <vx-card :title="$t('DashboardItems')">
        <div ref="container" style="overflow: hidden;" slot="no-body" class="mt-4">
          <vs-table stripe v-if="this.dashboardItemsData !== undefined && this.dashboardItemsData.length > 0" :data="dashboardItemsData" class="table-dark-inverted">
            <template slot="thead">
              <vs-th sort-key="recordType">{{$t('recordType')}}</vs-th>
              <vs-th sort-key="todayValue">{{$t('todayValue')}}</vs-th>
              <vs-th sort-key="thisMonthValue">{{$t('thisMonthValue')}}</vs-th>
              <vs-th sort-key="lastMonthValue">{{$t('lastMonthValue')}}</vs-th>
              <vs-th sort-key="AveragePerMonthValue">{{$t('AveragePerMonthValue')}}</vs-th>
              <vs-th sort-key="lastMonthValue">{{$t('lastMonthValue')}}</vs-th>
            </template>
            <template  slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].RecordType" width="40%">
                  {{$t(data[indextr].recordType)}}
                </vs-td>
                <vs-td :data="data[indextr].TodayValue" >
                  {{data[indextr].todayValue | moneyFormat(2, data[indextr].recordType === 'Lot' ? '' : '$', true)}}
                </vs-td>
                  <vs-td :data="data[indextr].thisMonthValue" >
                  {{data[indextr].thisMonthValue | moneyFormat(2, data[indextr].recordType === 'Lot' ? '' : '$', true)}}
                </vs-td>
                <vs-td :data="data[indextr].lastMonthValue" >
                  {{data[indextr].lastMonthValue | moneyFormat(2, data[indextr].recordType === 'Lot' ? '' : '$', true)}}
                </vs-td>
                <vs-td :data="data[indextr].averagePerMonthValue" >
                  {{data[indextr].averagePerMonthValue | moneyFormat(2, data[indextr].recordType === 'Lot' ? '' : '$', true) }}
                </vs-td>
                <vs-td :data="data[indextr].lastMonthValue" >
                  {{data[indextr].lastMonthValue | moneyFormat(2, data[indextr].recordType === 'Lot' ? '' : '$', true)}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>    
        </div> 
    </vx-card>
    </div>
    </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import smoothHeight from 'vue-smooth-height'

export default {
  mixins:[smoothHeight],
  components: {
    StatisticsCardLine
  },
  props: {
    cardData: {
      type: Array,
      required: true
    },
    dashboardItemsData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      language: 'en',
      hasDocument: true
    }
  },
  methods: {
    closeDocumentNotification () {
      this.$refs.vxAltert.removeCard()
      setTimeout(() => { this.hasDocument = false }, 350)
    }
  },
  mounted () {
    this.$smoothElement({
      el: this.$refs.container
    },
    {
      childTransitions: true,
      hideOverflow: true
    })
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  }
}
</script>